import { Spin, Drawer, Table, Tag } from "antd"
import StockOverviewHeader from "./StockOverviewHeader"
import StockMetrics from "./StockMetrics"
import StockTable from "./stock-table"
import Close from "../../../assets/images/close-x.svg";
import { LoadingOutlined } from '@ant-design/icons';
import '../../../styles/app.css'
import '../../../styles/antd.css'
import "antd/dist/antd.css";
import { useState, useEffect } from "react"
import { getStockTab, getStockHistory } from "../../../services/generic"

const Stockoverview = () => {
  const [selectedItemType, setSelectedItemType] = useState("all")
  const [selectedCategory, setSelectedCategory] = useState("all")     // → maps to itemType
  const [selectedLocation, setSelectedLocation] = useState("all")     // → maps to warehouseId
  const [searchQuery, setSearchQuery] = useState("")

  const [stockData, setStockData] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [page, setPage] = useState(0)
  const [hasMore, setHasMore] = useState(true)

  // Drawer & History state
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [historyData, setHistoryData] = useState([])
  const [historyLoading, setHistoryLoading] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)

  const fetchStockData = async (resetData = false) => {
    const pageSize = 50
    const currentPage = resetData ? 0 : page

    if (resetData) {
      setLoading(true)
      setPage(0)
      setHasMore(true)
    } else {
      setLoadingMore(true)
    }

    try {
      // Convert "all" → null, empty string → null (your backend likely expects null, not "")
      const warehouseId = selectedLocation === "all" ? "" : selectedLocation
      const itemType = selectedCategory === "all" ? "" : selectedCategory
      const searchKey = searchQuery.trim() === "" ? "" : searchQuery.trim()

      const response = await getStockTab(
        warehouseId,   // param 1
        itemType,      // param 2
        searchKey,     // param 3
        pageSize.toString(),           // limit
        (currentPage * pageSize).toString()              // offset
      )

      // Your API returns parsed array directly
      if (response && Array.isArray(response)) {
        console.log(response)
        if (resetData) {
          setStockData(response)
        } else {
          setStockData(prev => [...prev, ...response])
        }

        // If we received fewer items than page size, no more data available
        if (response.length < pageSize) {
          setHasMore(false)
        } else {
          setPage(currentPage + 1)
        }
      } else {
        if (resetData) {
          setStockData([])
        }
        setHasMore(false)
      }
    } catch (error) {
      console.error("Error fetching stock data:", error)
      if (resetData) {
        setStockData([])
      }
      setHasMore(false)
    } finally {
      setLoading(false)
      setLoadingMore(false)
    }
  }

  const handleLoadMore = () => {
    if (!loadingMore && hasMore) {
      fetchStockData(false)
    }
  }

  // Fetch on mount and whenever filters change
  useEffect(() => {
    // Only fetch data if a specific location is selected (not "all")
    if (selectedLocation !== "all") {
      fetchStockData(true) // Reset data when filters change
    } else {
      // Clear data when no location is selected
      setStockData([])
      setHasMore(false)
    }
  }, [selectedCategory, selectedLocation, searchQuery]) // Add searchQuery for live search

  // Optional: Debounced search (recommended for performance)
  // useEffect(() => {
  //   const timer = setTimeout(() => fetchStockData(), 400)
  //   return () => clearTimeout(timer)
  // }, [searchQuery])

  const handleRowClick = async (record) => {
    setSelectedProduct(record)
    setDrawerVisible(true)
    setHistoryLoading(true)
    setHistoryData([])

    try {
      // Assuming record.productid holds the ID we need
      // Adjust if the ID field is named differently in your data
      const data = await getStockHistory(record.productid)
      if (data) {
        setHistoryData(data)
      }
    } catch (error) {
      console.error("Error fetching history:", error)
    } finally {
      setHistoryLoading(false)
    }
  }

  const onCloseDrawer = () => {
    setDrawerVisible(false)
    setSelectedProduct(null)
    setHistoryData([])
  }

  const historyColumns = [
    {
      title: "Date",
      dataIndex: "creationdate",
      key: "creationdate",
      width: 150,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 100,
    },
    {
      title: "Created By",
      dataIndex: "createdby",
      key: "createdby",
      width: 120,
    },
    {
      title: "Old Count",
      dataIndex: "oldcount",
      key: "oldcount",
      width: 100,
      render: (val) => val?.toFixed(3)
    },
    {
      title: "Change Qty",
      dataIndex: "changeqty",
      key: "changeqty",
      width: 100,
      render: (val, record) => {
        const color = val > 0 ? "green" : "red"
        return <span style={{ color }}>{val > 0 ? `+${val.toFixed(3)}` : val.toFixed(3)}</span>
      }
    },
    {
      title: "New Count",
      dataIndex: "newcount",
      key: "newcount",
      width: 100,
      render: (val) => val?.toFixed(3)
    },
    {
      title: "Trx Cost",
      dataIndex: "trxcost",
      key: "trxcost",
      width: 100,
      render: (val) => val?.toFixed(3)
    }
  ]

  return (
    <div style={{ height: "100%", backgroundColor: '#fafafa', padding: 4 }}>
      <StockOverviewHeader
        selectedItemType={selectedItemType}
        setSelectedItemType={setSelectedItemType}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      {/* <StockMetrics data={stockData} loading={loading} /> */}

      <StockTable
        data={stockData}
        loading={loading}
        loadingMore={loadingMore}
        hasMore={hasMore}
        onLoadMore={handleLoadMore}
        selectedItemType={selectedItemType}
        selectedCategory={selectedCategory}
        selectedLocation={selectedLocation}
        searchQuery={searchQuery}
        onRowClick={handleRowClick}
      />

      <Drawer
        title={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h2 style={{ fontWeight: 'bold', padding: '10px 0px ', fontStyle: 'normal', float: 'left', marginLeft: "-7px" }}>{selectedProduct ? `Transaction History: ${selectedProduct.product}` : "Transaction History"}</h2>
          <img src={Close} alt="" style={{ height: "4vh", cursor: 'pointer', marginTop: "10px" }} onClick={onCloseDrawer} />
        </div>}
        placement="right"
        width={900}
        headerStyle={{ border: 'none' }}
        bodyStyle={{ padding: '0px 20px' }}
        onClose={onCloseDrawer}
        closeIcon={null}
        visible={drawerVisible}
      >
        {historyLoading ? (
          <div style={{ textAlign: "center", marginTop: 50 }}>
            <Spin size="large" indicator={<LoadingOutlined />} />
          </div>
        ) : (
          <Table
            dataSource={historyData}
            columns={historyColumns}
            sticky
            rowKey={(record, index) => index} // using index since no unique ID in sample
            pagination={false}
            size="small"
          />
        )}
      </Drawer>
    </div>
  )
}

export default Stockoverview